import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class OurNumbers {
    constructor() {
        this.section = document.querySelectorAll('.components-block-our-numbers');

        this.ready();
    }

    ready() {
        this.section.forEach((secao) => {
            const sliderSection = secao.querySelector('.swiper--components-block-our-numbers');
            const pagSlides = sliderSection.dataset.slides;
            const pagSlidesMedium = +sliderSection.dataset.slides - 1;
            const pagSlidesLow = +sliderSection.dataset.slides - 2;
            const swiper = new Swiper(sliderSection, {
                modules: [Navigation, Pagination],
                grabCursor: true,
                slidesPerView: 3,
                spaceBetween: 0,
                allowTouchMove: true,
                navigation: {
                    nextEl: secao.querySelector('.slider-button-next--components-block-our-numbers'),
                    prevEl: secao.querySelector('.slider-button-prev--components-block-our-numbers'),
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        pagination: {
                            el: secao.querySelector('.swiper-pagination-nav--components-block-our-numbers'),
                            type: 'fraction',
                        },
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        pagination: '',
                    },
                    780: {
                        slidesPerView: 3,
                        pagination: '',
                    },
                    1200: {
                        slidesPerView: pagSlides,
                        pagination: '',
                    },
                },
            });
        });
    }
}

if (document.querySelector('.components-block-our-numbers')) {
    new OurNumbers();
}
